<template>
    <div>
        <b-tabs
            class="apprentice-tab"
            v-model="activeTab"
            content-class="group-show-content"
            @input="updateTabIndex">
            <b-tab :title="$t('quest.progress')">
                <template v-slot:title>
                    {{ $t('quest.progress') }}
                </template>
                <design-2021-quest-rapport-table-component
                    :users="users"
                    :deadlines="quest.deadlines"
                    :groups="groups"></design-2021-quest-rapport-table-component>
            </b-tab>
            <b-tab :title="$t('quest.check')">
                <template v-slot:title>
                    {{ $t('quest.check') }}
                </template>
                <design-2021-quest-review-table-component
                    :quest-id="quest.id"
                    :group-id="group.id"
                    :groups="groups"
                    :users="users"></design-2021-quest-review-table-component>
            </b-tab>
            <b-tab :title="$t('quest.settings')">
                <template v-slot:title>
                    {{ $t('quest.settings') }}
                </template>
                <design-2021-quest-settings-component
                    :quest="quest"
                    :users="users"
                    :group="group"
                    :groups="groups"></design-2021-quest-settings-component>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
export default {
    name: 'design-2021-quest-overview-component',
    props: ['users', 'quest', 'groups', 'group'],
    data() {
        return {
            activeTab: 0,
            localStorageTitle: `session-${this.$authUser.id}-main-quest-review-${this.group.id}-Tab`,
        };
    },

    methods: {
        updateTabIndex(tabIndex) {
            this.activeTab = tabIndex;
            localStorage.setItem(this.localStorageTitle, tabIndex);
        },
    },

    created() {
        if (localStorage.getItem(this.localStorageTitle)) {
            this.activeTab = parseInt(localStorage.getItem(this.localStorageTitle));
        }
    },
};
</script>

<style scoped lang="scss">
.tabs ::v-deep .quest-edit-overview {
    padding-top: 16px;
    border-right: 1px solid $border-color;
    border-bottom: 1px solid $border-color;
}

.quest-edit-overview {
    color: $text-color;
}

.tabs ::v-deep .nav-link i {
        color: var(--primary);
    margin-right: map-get($grid-gutter-spacing, 'ten');
}
</style>
